export default function () {
  if (document.getElementById('deal-dashboard-app')) {
    import('@organisms/deal-dashboard/main');
  }
}
